var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.$route.params.formName === 'newStayForm')?_c('NewStayForm'):_vm._e(),(_vm.$route.params.formName === 'modifyStayForm')?_c('ModifyStayForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }